import _objectWithoutProperties from "/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["className", "jumpLinkData"];
var __jsx = React.createElement;
import React from 'react';
import styled from 'styled-components';
import styles from './Jumplink.style';
import uuidv1 from 'uuid/v1';
import List from '../../molecules/List';
import ListItem from '../../molecules/List/ListItem';
import Anchor from '../../atoms/Anchor';
import Heading from '../../atoms/Heading';
import componentAnalytics from '../../../constants/analyticsConstants';
var JumplinkBlock = styled.section.withConfig({
  componentId: "sc-1fm0vk-0"
})(["", ";"], styles);
var Jumplink = function Jumplink(_ref) {
  var className = _ref.className,
    jumpLinkData = _ref.jumpLinkData,
    others = _objectWithoutProperties(_ref, _excluded);
  return __jsx(JumplinkBlock, {
    className: "nva-jump-link ".concat(className)
  }, __jsx("div", {
    className: "jump-link"
  }, jumpLinkData && jumpLinkData.length > 1 && __jsx(List, {
    className: "nva-jump-link__nav nav navbar-nav row"
  }, jumpLinkData.map(function (jumpLinkItem, index) {
    return __jsx(ListItem, {
      key: uuidv1(),
      className: "nva-jump-link__nav-item col-xs-6 col-md-3"
    }, __jsx(Heading, {
      HeadingType: "h4",
      className: "nva-jump-link__nav-item-heading"
    }, jumpLinkItem.anchorLink && __jsx(Anchor, {
      title: jumpLinkItem.linkLabel,
      "aria-label": jumpLinkItem.ariaLabel,
      to: jumpLinkItem.anchorLink,
      className: "nva-jump-link__nav-item-anchor-link jump-link-anchor",
      "data-analytics-type": componentAnalytics.jumpLink.analyticsType.TOP_LINK,
      "data-analytics-value": "",
      "data-analytics-variation": ""
    }, jumpLinkItem.linkLabel), jumpLinkItem.url && __jsx(Anchor, {
      title: jumpLinkItem.label,
      "aria-label": jumpLinkItem.ariaLabel,
      to: jumpLinkItem.url,
      className: "nva-jump-link__nav-item-anchor-url jump-link-anchor",
      ctaBehavior: jumpLinkItem.behavior,
      "data-analytics-type": componentAnalytics.jumpLink.analyticsType.TOP_LINK,
      "data-analytics-value": "",
      "data-analytics-variation": ""
    }, jumpLinkItem.label)));
  }))));
};
Jumplink.defaultProps = {
  className: '',
  ariaLabel: ''
};
export default styled(Jumplink).withConfig({
  componentId: "sc-1fm0vk-1"
})(["", ";"], styles);
export { Jumplink as JumplinkVanilla };